import { useMutation, useQuery } from "@apollo/client"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { IAppointmentListEntry, IGetAppointmentsAndTicklersOutput, IGetAppointmentsList } from "../graphql/types/queries/appointment"
import { ADMIN_GET_APPOINTMENTS_LIST, GET_APPOINTMENT_NOTES, GET_APPOINTMENT_SUMMARY } from "../graphql/queries"
import styled from "styled-components";
import { Box, Button, Card, Flex, Heading, Text } from "rebass/styled-components";
import { HoverableCard } from "../components/HoverableCard";
import moment from "moment";
import { Constants } from "../utils/Constants";
import { PatientEmbed } from "./Patient";
import { getMockedFirstName, getMockedLastName, getMockedPhone } from "../utils/mocks";
import { ProfileCardSection } from "./messages/ProfileCardSection";
import { InputNoForm } from "../components/TextInput";
import Modal from "styled-react-modal";
import { Checkbox } from "../components/CheckboxInput";
import CalendarGrid from "./dashboard/CalendarGrid";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { AppointmentDetails } from "./preCheckin/AppointmentDetails";
import { MARK_CHART_AS_PREPPED, UNMARK_CHART_AS_PREPPED } from "../graphql/mutations";
import { IMarkChartAsPreppedInput, IMarkChartAsPreppedOutput, IUnmarkChartAsPreppedInput, IUnmarkChartAsPreppedOutput } from "../graphql/types/mutations/appointment";
import Toggle from "react-toggle";
import { toast } from "react-toastify";
import { Skeleton } from "../components/loadingSkeleton/Skeleton";

const PatientDetailsFloatingContainer = styled(Flex)`
  display: flex;
  z-index: 10;
`

const Wrapper = styled(Flex)`
  overflow: auto;
  flex-direction: column;
  flex: 1;
  &:hover {
    overflow-y: auto;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const PatientDetailsContainer = styled(Flex)`
  display: none;
  
  @media screen and (min-width: 1780px) {
    margin-left: 20px;
    display: flex;
    min-width: 600px;
    max-width: 600px;
  }
`

const Container = styled(Flex)`
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  @media screen and (min-width: 68.8125em) {
  padding: ${() => `${Constants.OUTLETS_PADDING}px`};
  padding-right: ${() => `12px`};
  padding-top: ${() => `1px`};
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  }
`

const ListContainer = styled(Flex)`
  min-width: 300px;
  width: 100%;
  overflow-y: auto;
  &.selected {
    display: none;
  }

  @media screen and (min-width: 68.8125em) {
    &.selected {
      display: flex;
    }
  }
`;

const isNonMemberAppointmentType = (appointmentTypeId: number | string, isZocDoc: boolean) => {
  if (isZocDoc) return 'zocdoc'

  switch (appointmentTypeId.toString()) {
    case (window as any)._env_.REACT_APP_ATHENA_FUVISIT15_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_CONSULT30_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_NEWVISIT30_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_FOLLOWUP15_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_FOLLOWUP30_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_FUVISIT30_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_BRIDGE_FUVISIT15_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_BRIDGE_FUVISIT30_APPOINTMENT_TYPE_ID.toString():
    case (window as any)._env_.REACT_APP_ATHENA_BRIDGE_NEWVISIT30_APPOINTMENT_TYPE_ID.toString():
      return 'nonmember'
    default:
      return 'member'
  }
}

const getTypeAndColor = (appointmentTypeId: number | string) => {
  if (!appointmentTypeId) {

    return {
      title: 'hypo',
      background: 'rgba(146, 196, 255, 0.5)',
      color: '#216CBC'
    }
  }
  if (appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_MENO15_APPOINTMENT_TYPE_ID.toString() || 
  appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_MENO30_APPOINTMENT_TYPE_ID.toString() || 
  appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_BRIDGE_MENO15_APPOINTMENT_TYPE_ID.toString() || 
  appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_BRIDGE_MENO30_APPOINTMENT_TYPE_ID.toString()) {
    return {
      title: 'meno',
      background: 'rgba(255, 153, 187, 0.5)',
      color: '#B54D2D'
    }
  }
  if (appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString() ||
    appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString() ||
    appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_B2B_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString() ||
    appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_B2B_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString()||
    appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_BRIDGE_WEIGHTLOSS15_APPOINTMENT_TYPE_ID.toString() ||
    appointmentTypeId.toString() === (window as any)._env_.REACT_APP_ATHENA_BRIDGE_WEIGHTLOSS30_APPOINTMENT_TYPE_ID.toString()) {
    return {
      title: 'WL',
      background: 'rgba(215, 179, 235,0.5)',
      color: '#661A90'
    }
  }

  return {
    title: 'hypo',
    background: 'rgba(146, 196, 255, 0.5)',
    color: '#216CBC'
  }
}

const VISIT_TYPES = ['hypo', 'meno', 'WL']

const Row = ({ row,
  onGoToProfile,
  hoveredId,
  setHover,
  previousRow,
}: {
  row: IAppointmentListEntry,
  previousRow: IAppointmentListEntry | null,
  setHover: (id: string | null) => void,
  onGoToProfile: () => void,
  hoveredId: string | null,
}) => {
  const toastId = useRef<any>(null);

  const [isConfirmChartPrep, setIsConfirmChartPrep] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const fullDate = moment(`${row.date} ${row.startTime}`, 'MM/DD/YYYY HH:mm:ss')
  let isFutureDate = moment().isBefore(fullDate)

  const [markChartAsPreppedMutate] = useMutation<IMarkChartAsPreppedOutput, IMarkChartAsPreppedInput>(MARK_CHART_AS_PREPPED, {
    onCompleted: e => {
      if (e.markChartAsPrepped && e.markChartAsPrepped.ok) {
        toast.update(toastId.current, {
          render: 'Chart marked as prepped!',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.update(toastId.current, {
          render: 'Failed to mark as prepped!',
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
    },
    onError: e => {
      toast.update(toastId.current, {
        render: 'Failed to mark as prepped!',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    },
    refetchQueries: [{ query: GET_APPOINTMENT_SUMMARY, variables: { appointmentId: row.appointmentId } }, { query: GET_APPOINTMENT_NOTES, variables: { appointmentId: row.appointmentId } }],
    awaitRefetchQueries: true,
    updateQueries: {
      healthCoachListUpcomingAppointments: (prev, r) => {
        let a = JSON.parse(JSON.stringify(prev)) as IGetAppointmentsList
        for (let index = 0; index < a.healthCoachListUpcomingAppointments.length; index++) {
          const element = a.healthCoachListUpcomingAppointments[index];
          if (element.appointmentId === row.appointmentId) {
            element.isChartPrepped = true
          }
        }
        return a
      },
      healthCoachGetAppointmentsAndTicklers: (prev, r) => {
        if (!prev) return prev
        let a = JSON.parse(JSON.stringify(prev)) as IGetAppointmentsAndTicklersOutput
        for (let index = 0; index < a.healthCoachGetAppointmentsAndTicklers.appointments.length; index++) {
          const element = a.healthCoachGetAppointmentsAndTicklers.appointments[index];
          if (element.id === row.appointmentId) {
            element.isPrepped = true
          }
        }
        return a
      }
    }
  })
  const [unmarkChartAsPreppedMutate] = useMutation<IUnmarkChartAsPreppedOutput, IUnmarkChartAsPreppedInput>(UNMARK_CHART_AS_PREPPED, {
    onCompleted: e => {
      if (e.unmarkChartAsPrepped && e.unmarkChartAsPrepped.ok) {
        toast.update(toastId.current, {
          render: 'Chart marked as unprepped!',
          type: toast.TYPE.SUCCESS,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      } else {
        toast.update(toastId.current, {
          render: 'Failed to mark as unprepped!',
          type: toast.TYPE.ERROR,
          isLoading: false,
          autoClose: 5000,
          closeButton: null // The closeButton defined on ToastContainer will be used
        });
      }
    },
    onError: e => {
      toast.update(toastId.current, {
        render: 'Failed to mark as unprepped!',
        type: toast.TYPE.ERROR,
        isLoading: false,
        autoClose: 5000,
        closeButton: null // The closeButton defined on ToastContainer will be used
      });
    },
    refetchQueries: [{ query: GET_APPOINTMENT_SUMMARY, variables: { appointmentId: row.appointmentId } }, { query: GET_APPOINTMENT_NOTES, variables: { appointmentId: row.appointmentId } }],
    awaitRefetchQueries: true,
    updateQueries: {
      healthCoachListUpcomingAppointments: (prev, r) => {
        let a = JSON.parse(JSON.stringify(prev)) as IGetAppointmentsList
        for (let index = 0; index < a.healthCoachListUpcomingAppointments.length; index++) {
          const element = a.healthCoachListUpcomingAppointments[index];
          if (element.appointmentId === row.appointmentId) {
            element.isChartPrepped = false
          }
        }
        return a
      },
      healthCoachGetAppointmentsAndTicklers: (prev, r) => {
        if (!prev) return prev
        let a = JSON.parse(JSON.stringify(prev)) as IGetAppointmentsAndTicklersOutput
        for (let index = 0; index < a.healthCoachGetAppointmentsAndTicklers.appointments.length; index++) {
          const element = a.healthCoachGetAppointmentsAndTicklers.appointments[index];
          if (element.id === row.appointmentId) {
            element.isPrepped = false
          }
        }
        return a
      }
    }
  })
  const markChartAsPrepped = (appointmentId: string, patientId: string) => {
    if (!row.isChartPrepped) {
      toastId.current = toast("Marking Chart as Prepped", { autoClose: false, isLoading: true, closeButton: false });
      markChartAsPreppedMutate({
        variables: {
          appointmentId,
          patientId
        },
      })
    } else {
      toastId.current = toast("Unmarking Chart as Prepped", { autoClose: false, isLoading: true, closeButton: false });
      unmarkChartAsPreppedMutate({
        variables: {
          appointmentId,
          patientId
        },
      })
    }
  }
  return (
    <>
      {!previousRow || previousRow.date !== row.date ? (
        <Flex style={{ alignItems: 'center', opacity: 0.7 }} mt={3} mb={2}>
          <Box style={{ height: 1, flex: 1, background: '#7992B3', opacity: 0.5 }} />
          <Text style={{ color: '#7992B3', margin: '0 24px', fontSize: '10px', fontWeight: 500 }}>{row.date}</Text>
          <Box style={{ height: 1, flex: 1, background: '#7992B3', opacity: 0.5 }} />
        </Flex>
      ) : null}

      <HoverableCard onClick={onGoToProfile} style={{
        opacity: !!row.isChartPrepped ? !!hoveredId && hoveredId === row.appointmentId?.toString() ? 1 : 0.65 : !hoveredId || hoveredId === row.appointmentId?.toString() ? 1 : 0.7,
        boxShadow: !hoveredId || hoveredId === row.appointmentId?.toString() ? '0px 4px 20px rgb(0 0 0 / 10%)' : '0px 4px 20px rgb(0 0 0 / 0%)',
        cursor: 'pointer',
        borderLeft: !!row.isChartPrepped ? '5px solid green' : ''
      }}
        id={row.appointmentId.toString()}
        hoveredId={hoveredId}
        setHover={setHover}>
        <Flex flexDirection={'column'} style={{ width: '100%' }}>
          <Flex style={{ width: '100%', minHeight: '82px', padding: '18px 12px' }}>
            <Flex flex={1} flexDirection={['column', 'row', 'row']}>
              <Flex flex={1}>

                <Box width={'24px'} height={'18px'} style={{ alignSelf: 'center' }}>
                  {row.isZocDoc ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path opacity={0.6} d="M19.9015 10.6015C19.9015 18.6205 19.4515 21.75 15.286 21.75C10.2985 21.75 4.09851 14.2 4.09851 9.115C4.09851 5.3235 7.17201 2.25 10.9635 2.25C14.755 2.25 19.9015 5.008 19.9015 10.6015Z" stroke="#344F7A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                      <path opacity={0.6} d="M7.38402 12.9075C7.90731 12.9075 8.33152 12.4832 8.33152 11.96C8.33152 11.4367 7.90731 11.0125 7.38402 11.0125C6.86073 11.0125 6.43652 11.4367 6.43652 11.96C6.43652 12.4832 6.86073 12.9075 7.38402 12.9075Z" stroke="#344F7A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                      <path opacity={0.6} d="M15.6565 12.9075C16.1798 12.9075 16.604 12.4832 16.604 11.96C16.604 11.4367 16.1798 11.0125 15.6565 11.0125C15.1332 11.0125 14.709 11.4367 14.709 11.96C14.709 12.4832 15.1332 12.9075 15.6565 12.9075Z" stroke="#344F7A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                      <path opacity={0.6} d="M7.38403 6.16199H15.286L7.58603 17.5135C10.3535 18.8135 13.604 18.611 15.98 17.3785" stroke="#344F7A" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                  ) : isNonMemberAppointmentType(row.appointmentId, row.isZocDoc) === 'member' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#344F7A" strokeOpacity="0.5"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                      <path d="M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15" /><path d="M11 12 5.12 2.2" /><path d="m13 12 5.88-9.8" /><path d="M8 7h8" /><circle cx="12" cy="17" r="5" /><path d="M12 18v-2h-.5" /></svg>
                    // <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //   <path opacity="0.3" d="M4 4H20V10H4V4ZM4 13H20V15H4V13Z" fill="#344F7A" />
                    //   <path opacity={0.6} d="M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z" fill="#344F7A" />
                    // </svg>
                  ) : null}

                </Box>
                <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>

                <Box width={'80px'} style={{ alignSelf: 'center' }}>
                  <Text textAlign={'center'} style={{ color: '#7992B3', fontSize: '12px', fontWeight: 700 }}>{row.patientId}</Text>
                </Box>
                <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
                <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
                  <Text style={{ color: '#7992B3', fontSize: '12px', fontWeight: 700 }}>{`${row.patient && row.patient.firstName ? `${row.patient.firstName[0]}.` : ''}`}{`${row.patient ? row.patient.lastName : ''}`}</Text>
                </Box>
              </Flex>
              <Box style={{ background: '#E2E2E2' }} width={[0, '1px', '1px']}></Box>
              <Flex flex={1}>
                <Box style={{ flex: 1, paddingLeft: '12px', alignSelf: 'center' }}>
                  <Text style={{ color: '#7992B3', fontSize: '12px' }}>{`${row.providerName || row.providerId}`}</Text>
                </Box>
              </Flex>
              <Box style={{ background: '#E2E2E2' }} width={[0, '1px', '1px']}></Box>
              <Flex flex={1} flexDirection={'column'}>
                <Box flex={['initial', 1, 1]} paddingRight={['12px', '', '']} style={{ paddingLeft: '12px' }}>
                  <Text style={{ color: '#7992B3', fontSize: '12px' }}>{`${moment(row.date).format('ddd MMM Do YYYY')}`}</Text>
                </Box>
                <Flex width={['', '280px', '280px']} style={{ paddingLeft: '12px', }}>
                  <Flex flexDirection={'column'} flex={1} justifyContent='center'>
                    <Text style={{ color: '#7992B3', fontSize: '12px' }}>{`${moment(row.startTime, 'HH:mm')
                      .format('h:mma')} - ${row.duration} minutes`}</Text>
                  </Flex>
                </Flex>
              </Flex>
              <Box style={{ width: '1px', background: '#E2E2E2' }}></Box>
              <Flex width={'130px'} style={{ paddingLeft: '12px', alignSelf: 'center', gap: 2 }} alignItems={'center'}>
                <Flex flexDirection={'column'} flex={1} justifyContent='center'>
                  <div
                    style={{
                      background: row.mustCompleteRegistration ? '#b00412' : '#344f79',
                      display: row.isZocDoc ? '' : 'none',
                      borderRadius: '10px', padding: '3px 12px', alignSelf: 'flex-start',
                      marginBottom: '4px'
                    }}
                  >
                    <Text
                      fontSize="12px"
                      color="white"
                      style={{
                        color: 'white',
                      }}
                    >
                      <span>ZocDoc</span>
                    </Text>
                  </div>
                  <Box style={{ background: getTypeAndColor(row.appointmentTypeId)?.background, borderRadius: '10px', padding: '3px 12px', alignSelf: 'flex-start' }}>
                    <Text color={getTypeAndColor(row.appointmentTypeId)?.color} fontSize='12px'>{getTypeAndColor(row.appointmentTypeId)?.title} {row.duration}</Text>
                  </Box>
                </Flex>
                <svg onClick={e => {
                  e.preventDefault()
                  e.stopPropagation()
                  setIsConfirmChartPrep(true)
                }} width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15" stroke="#344F7A" strokeOpacity="0.6"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 17V12M12 17V16M15 17V14M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5C15 5.53043 14.7893 6.03914 14.4142 6.41421C14.0391 6.78929 13.5304 7 13 7H11C10.4696 7 9.96086 6.78929 9.58579 6.41421C9.21071 6.03914 9 5.53043 9 5Z" stroke="#344F7A" strokeOpacity="0.6"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {!!isExpanded ? (
                  <svg style={{ cursor: 'pointer' }} onClick={e => {
                    e.stopPropagation()
                    setIsExpanded(false)
                  }} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#344F7A" strokeOpacity="0.6"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="m18 15-6-6-6 6" /></svg>
                ) : (
                  <svg style={{ cursor: 'pointer' }} onClick={e => {
                    e.stopPropagation()
                    setIsExpanded(true)
                  }} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#344F7A" strokeOpacity="0.6"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="m6 9 6 6 6-6" /></svg>
                )}



              </Flex>
            </Flex>
          </Flex>
          {!!isExpanded && (
            <Flex p={3}>
              <AppointmentDetails data={row} isPast={!isFutureDate} />
            </Flex>
          )}

          {!!isConfirmChartPrep && (
            <Modal
              isOpen={isConfirmChartPrep}
              onBackgroundClick={() => setIsConfirmChartPrep(false)}
              onEscapeKeydown={() => setIsConfirmChartPrep(false)}>
              <Flex flexDirection={'column'} style={{ margin: '0 auto', overflow: 'hidden', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', maxHeight: '80vh' }}>
                <Heading mb={3}>Confirmation</Heading>
                <Text>{row.isChartPrepped ? 'Unmark' : 'Mark'} Chart as Prepped?</Text>
                <Flex justifyContent={'space-between'}>

                  <Button variant={'pink'} mt={4} onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setIsConfirmChartPrep(false)
                    markChartAsPrepped(row.appointmentId, row.patientId)
                  }}>Yes</Button>
                  <Button variant={'primary'} ml={4} mt={4} onClick={() => {
                    setIsConfirmChartPrep(false)
                  }}>Cancel</Button>
                </Flex>

              </Flex>
            </Modal>
          )}
        </Flex>
      </HoverableCard>
    </>
  )
}

export const PreCheckin = () => {
  const { data, loading, refetch, error } = useQuery<IGetAppointmentsList>(ADMIN_GET_APPOINTMENTS_LIST, {
    notifyOnNetworkStatusChange: true
  })
  const [hidePrepped, setHidePrepped] = useState(true)
  const [selectedAppointment, setSelectedAppointment] = useState<IAppointmentListEntry | null>(null)
  const [hoveredId, setHoveredId] = useState<string | null>(null)
  const [search, setSearch] = useState<string>('')
  const [prefix, setPrefix] = useState<'' | null | 'name' | 'athenaId'>(null)
  const [filteredProvider, setFilterProvider] = useState<Array<string>>([])
  const [filteredTypes, setFilterTypes] = useState<Array<string>>([])
  const [filteredDates, setFilterDates] = useState<{ startDate: Date | null, endDate: Date | null } | null>(null)
  const [filteredMember, setFilterMember] = useState<Array<'all' | 'member' | 'nonmember' | 'zocdoc'>>(['all'])
  const [isSelectfilteredProvider, setisSelectFilterProvider] = useState<boolean>(false)
  const [isSelectfilteredTypes, setisSelectFilterTypes] = useState<boolean>(false)
  const [isSelectfilteredDates, setisSelectFilterDates] = useState<boolean>(false)
  const [isSelectfilteredMember, setisSelectFilterMember] = useState<boolean>(false)
  const searchRef = useRef<any>()

  useEffect(() => {
    if (!search) {
      setPrefix(null)
      return
    }

    let value: string | number

    try {
      value = parseInt(search)
    } catch (error) {
      value = search
    }

    if (!value) {
      value = search
    }

    if (isNaN(value as any)) {
      setPrefix('name')
    } else {
      setPrefix('athenaId')
    }
  }, [search])

  const getNumbersUnprepped = useCallback(() => {
    if (!data || !data.healthCoachListUpcomingAppointments) {
      return {
        filtered: 0,
        total: 0
      }
    }
    return {
      filtered: data.healthCoachListUpcomingAppointments.filter(xx => filtering(xx) && !xx.isChartPrepped).length,
      total: data.healthCoachListUpcomingAppointments.filter(xx => !xx.isChartPrepped).length
    }
  }, [data, data?.healthCoachListUpcomingAppointments, filteredProvider, filteredTypes, search, hidePrepped, filteredDates, filteredMember, filteredMember.length])

  const getNumbersPrepped = useCallback(() => {
    if (!data || !data.healthCoachListUpcomingAppointments) {
      return {
        filtered: 0,
        total: 0
      }
    }
    return {
      filtered: data.healthCoachListUpcomingAppointments.filter(xx => filtering(xx, true) && !!xx.isChartPrepped).length,
      total: data.healthCoachListUpcomingAppointments.filter(xx => !!xx.isChartPrepped).length
    }
  }, [data, data?.healthCoachListUpcomingAppointments, filteredProvider, filteredTypes, search, hidePrepped, filteredDates, filteredMember, filteredMember.length])


  const filtering = useCallback((entry: IAppointmentListEntry, bypassPrepCheck:boolean=false) => {
    if (!bypassPrepCheck && !!hidePrepped && entry.isChartPrepped) return false
    if (!search && filteredProvider.length < 1 && filteredTypes.length < 1 && (!filteredDates || !filteredDates?.startDate && !filteredDates?.endDate) && !filteredMember) return true

    let visible = false
    if (!!search) {
      visible = entry.patientId.indexOf(search) > -1 || (!!entry.patient && (!!(entry.patient.firstName && entry.patient.firstName?.toLowerCase().indexOf(search) > -1) || !!(entry.patient.lastName && entry.patient.lastName?.toLowerCase().indexOf(search) > -1)))
      if (!visible) return false
    }
    if (filteredProvider && filteredProvider.length > 0) {
      if (filteredProvider.indexOf(entry.providerName) > -1) {
        visible = true
      }
      if (!visible) return false
    }

    if (filteredTypes && filteredTypes.length > 0) {
      if (filteredTypes.indexOf(getTypeAndColor(entry.appointmentTypeId).title) > -1) {
        visible = true
      }
      if (!visible) return false
    }

    if (!!filteredDates) {
      if (!!filteredDates.startDate) {

        if (filteredDates.endDate) {
          visible = moment(entry.date, 'MM/DD/YYYY').isSameOrAfter(moment(filteredDates.startDate), 'day')
          visible = moment(entry.date, 'MM/DD/YYYY').isSameOrBefore(moment(filteredDates.endDate), 'day')
          if (!visible) return false
        } else {
          visible = moment(entry.date, 'MM/DD/YYYY').isSame(moment(filteredDates.startDate), 'day')
          if (!visible) return false
        }
      }
      if (!visible) return false
    }

    console.log('@@debug', 'filtering')
    if (filteredMember && filteredMember.indexOf('all') < 0) {
      const type = isNonMemberAppointmentType(entry.appointmentTypeId, entry.isZocDoc)
      console.log({ type, filteredMember })
      if (type === 'member' && filteredMember.indexOf('member') > -1) {
        visible = true
      }
      if (type === 'zocdoc' && filteredMember.indexOf('zocdoc') > -1) {
        console.log('@@debug', 'found')
        visible = true
      }
      if (type === 'nonmember' && filteredMember.indexOf('nonmember') > -1) {
        visible = true
      }

      if (!visible) return false
    } else if (filteredMember.indexOf('all') > -1) {
      visible = true
    }

    return visible
  }, [data, data?.healthCoachListUpcomingAppointments, filteredProvider, filteredTypes, search, hidePrepped, filteredDates, filteredMember, filteredMember.length])


  const getListProviders = () => {
    const res = []
    if (!data || !data.healthCoachListUpcomingAppointments) return []
    for (let index = 0; index < data.healthCoachListUpcomingAppointments.length; index++) {
      const element = data.healthCoachListUpcomingAppointments[index];
      if (res.indexOf(element.providerName) < 0) {
        res.push(element.providerName)
      }
    }

    return res
  }

  const getDatesRange = () => {
    if (!data || !data.healthCoachListUpcomingAppointments) return {
      from: new Date(),
      to: new Date()
    }
    const oldest = data.healthCoachListUpcomingAppointments.reduce((oldest, current) => {
      const currentDate = new Date(current.date);
      const oldestDate = new Date(oldest.date);

      return currentDate < oldestDate ? current : oldest;
    }, data.healthCoachListUpcomingAppointments[0]);
    const latest = data.healthCoachListUpcomingAppointments.reduce((latest, current) => {
      const currentDate = new Date(current.date);
      const latestDate = new Date(latest.date);

      return currentDate > latestDate ? current : latest;
    }, data.healthCoachListUpcomingAppointments[0]);

    return {
      from: moment(oldest.date).toDate(),
      to: moment(latest.date).toDate()
    }
  }

  return (
    <Container flexDirection={'row'} style={{ height: '100%', maxHeight: '100%' }} overflowY={['hidden']}>
      <Flex flexDirection={'column'} style={{ height: '100%', maxHeight: '100%', maxWidth: '900px' }} overflowY={['auto', 'hidden', 'hidden']} flex={1}
        paddingTop={`${Constants.OUTLETS_PADDING_TOP}px`}>
        <Flex mb={3} alignItems={'center'}>
          <Heading mr={4}>Pre-check-In</Heading>
          {!loading && (
            <Flex alignItems={'center'}>
              <Checkbox isChecked={!hidePrepped} labelStyle={{ fontSize: '12px' }} onClick={() => {
                setHidePrepped(!hidePrepped)
              }}
                label={'Show Prepped Charts'} />
            </Flex>
          )}
          <Flex flex={1} justifyContent={'flex-end'}>
          </Flex>
          <Flex >
            <Button variant={'outline'} justifySelf={'flex-end'} onClick={async () => {
              refetch()
            }} disabled={loading}>

              <Flex alignItems={'center'} justifyContent={'center'} style={{ gap: "12px" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="#344F7A" strokeOpacity="0.6"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 6H3" />
                  <path d="M7 12H3" />
                  <path d="M7 18H3" />
                  <path d="M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14" />
                  <path d="M11 10v4h4" />
                </svg>
                <Text fontSize={'12px'}>{loading ? 'Loading' : 'Refresh'}</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
        {!!loading ? (
          <>
            <Flex flexDirection={'column'}>
              <Skeleton height={20} width={303} />
              <Skeleton height={50} width={'100%'} style={{ marginTop: '16px' }} />
            </Flex>

            <Flex flexDirection={'column'} style={{ height: '100%' }} mt={4}>
              <Flex flex={1} maxHeight={['100%']}>
                <ListContainer
                  width={'100%'}
                  maxWidth={'100%'}
                  className={''}>
                  <Flex style={{
                    flex: 'initial',
                    minWidth: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    borderRadius: '0',
                    overflow: 'hidden',
                    display: 'flex',
                    background: 'transparent',
                    flexDirection: 'column',
                    padding: '0',
                    gap: '12px'
                  }}>
                    <Flex padding={'0px 12px'}>
                      <Flex flex={1} justifyContent={'center'} >
                        <Skeleton height={20} width={75} />

                      </Flex>
                      <Flex flex={1} flexDirection={'column'} >
                        <Skeleton height={20} width={82} />
                      </Flex>
                      <Flex flex={1} justifyContent={'center'} >
                        <Skeleton height={20} width={120} />
                      </Flex>
                      <Flex width={'130px'} flexDirection={'column'} onClick={() => setisSelectFilterTypes(true)}>
                        <Flex justifyContent={'center'}>
                          <Skeleton height={20} width={60} />
                        </Flex>
                      </Flex>
                    </Flex>

                    {[0, 1, 2].map((e, i, lst) => (
                      <Skeleton height={82} width={'100%'} style={{ marginBottom: '12px' }} />
                    ))}

                  </Flex>
                </ListContainer>
              </Flex>
            </Flex>
          </>
        ) : (
          <>
            {!data || !data.healthCoachListUpcomingAppointments ? (
              <Text style={{ textAlign: 'center', opacity: 0.75, fontSize: '14px' }} mt={5}>An error occured</Text>
            ) : (
              <>

                <Flex flexDirection={'column'}>
                  <Text style={{ fontWeight: 400, color: 'rgba(52, 79, 122, 0.6)' }}>Search patients by name or patient ID</Text>

                  <Flex mt={3} flexDirection={'row'} style={{ background: 'white', borderRadius: '12px', padding: '0 12px', overflow: "hidden" }} alignItems='center'
                    onClick={() => {
                    }}>
                    {!!prefix ? (
                      <Box style={{ background: prefix === 'name' ? '#aeeedb' : '#FFE6E2', height: '100%', margin: '0 0 0 -12px', display: 'flex', alignItems: 'center', padding: '0 8px 0 12px', marginRight: '12px' }}>
                        <Text style={{ fontSize: '14px' }} color={prefix === 'name' ? '#46937c' : '#F6A293'}>{prefix === 'name' ? 'name:' : 'Athena ID:'}</Text>
                      </Box>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="#344F7A" strokeOpacity="0.6"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" >
                        <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    )}
                    <InputNoForm type="search"
                      inputRef={searchRef}
                      autoFocus
                      onChange={(e: any) => {
                        setSearch(e.target.value)
                      }}
                      field={{
                        style: { backgroundColor: 'white', border: '0px', flex: 1, fontSize: '14px', paddingTop: '4px', paddingBottom: '4px' }
                      }}

                      value={search}
                      containerStyle={{ flex: 1 }}
                      placeholder='last name or patient id' />

                  </Flex>
                </Flex>
                <Flex flexDirection={'column'} id='ttppt' style={{ overflow: 'hidden' }} mt={4}>
                  <Flex flex={1} maxHeight={['100%']}>
                    <ListContainer
                      width={'100%'}
                      maxWidth={'100%'}
                      className={''}>
                      <Flex style={{
                        flex: 1,
                        minWidth: '100%',
                        maxWidth: '100%',
                        borderRadius: '0',
                        overflow: 'hidden',
                        display: 'flex',
                        background: 'transparent',
                        flexDirection: 'column',
                        padding: '0',
                        gap: '12px',
                      }}>
                        <Flex padding={'0px 12px'}>
                          <Box width={'24px'} height={'18px'} style={{ alignSelf: 'center' }} onClick={() => setisSelectFilterMember(true)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#344F7A" strokeOpacity="0.5"
                              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" >
                              <path d="M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15" /><path d="M11 12 5.12 2.2" /><path d="m13 12 5.88-9.8" /><path d="M8 7h8" /><circle cx="12" cy="17" r="5" /><path d="M12 18v-2h-.5" /></svg>


                          </Box>
                          <Flex flex={1} justifyContent={'center'} onClick={() => {
                            if (searchRef && searchRef.current) {
                              searchRef.current.focus()
                            }
                          }}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.75 15.75L12.3855 12.3795L15.75 15.75ZM14.25 7.875C14.25 9.56576 13.5784 11.1873 12.3828 12.3828C11.1873 13.5784 9.56576 14.25 7.875 14.25C6.18424 14.25 4.56274 13.5784 3.36719 12.3828C2.17165 11.1873 1.5 9.56576 1.5 7.875C1.5 6.18424 2.17165 4.56274 3.36719 3.36719C4.56274 2.17165 6.18424 1.5 7.875 1.5C9.56576 1.5 11.1873 2.17165 12.3828 3.36719C13.5784 4.56274 14.25 6.18424 14.25 7.875V7.875Z" stroke="#344F7A" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                            <Text ml={2} style={{ fontSize: '13px', opacity: 0.83 }}>Patient</Text>
                          </Flex>
                          <Flex flex={1} flexDirection={'column'} onClick={() => setisSelectFilterProvider(true)}>


                            <Flex justifyContent={'center'}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                stroke="#344F7A" strokeOpacity="0.6"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
                              <Text ml={2} style={{ fontSize: '13px', opacity: 0.83 }}>Provider</Text>
                            </Flex>
                            {filteredProvider.length > 0 && filteredProvider.length !== getListProviders().length && (
                              <Flex ml={2} style={{ borderRadius: '6px', cursor: 'pointer', padding: '0 8px', border: '1px solid #344F7A', background: '#fafafa', opacity: '0.5', alignSelf: 'center' }} onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setFilterProvider([])
                              }}>
                                <Text fontSize={'10px'}><span style={{ fontWeight: 700 }}>{filteredProvider.length}</span> selected</Text>
                                <Text ml={2} fontSize={'10px'}>X</Text>
                              </Flex>
                            )}
                          </Flex>
                          <Flex flexDirection={'column'} flex={1} onClick={() => setisSelectFilterDates(true)}>
                            <Flex justifyContent={'center'}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                stroke="#344F7A" strokeOpacity="0.6"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
                              <Text ml={2} style={{ fontSize: '13px', opacity: 0.83 }}>Appointment Date</Text>
                            </Flex>

                            {filteredDates && filteredDates.startDate && (
                              <Flex ml={2} style={{ borderRadius: '6px', cursor: 'pointer', padding: '0 8px', border: '1px solid #344F7A', background: '#fafafa', opacity: '0.5', alignSelf: 'center' }} onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setFilterDates(null)
                              }}>
                                <Text fontSize={'10px'} >{filteredDates.startDate.toDateString()}{filteredDates.endDate ? ` - ${filteredDates.endDate.toDateString()}` : ''}</Text>
                                <Text ml={2} fontSize={'10px'}>X</Text>
                              </Flex>
                            )}
                          </Flex>
                          <Flex width={'130px'} flexDirection={'column'} onClick={() => setisSelectFilterTypes(true)}>
                            <Flex justifyContent={'center'}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                stroke="#344F7A" strokeOpacity="0.6"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
                              <Text style={{ fontSize: '13px', opacity: 0.83 }} ml={2}>Type</Text>

                            </Flex>

                            {filteredTypes.length > 0 && filteredTypes.length !== VISIT_TYPES.length && (
                              <Flex ml={2} style={{ borderRadius: '6px', cursor: 'pointer', padding: '0 8px', border: '1px solid #344F7A', background: '#fafafa', opacity: '0.5', alignSelf: 'center' }} onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setFilterTypes([])
                              }}>
                                <Text fontSize={'10px'} ><span style={{ fontWeight: 700 }}>{filteredTypes.length}</span> selected</Text>
                                <Text ml={2} fontSize={'10px'}>X</Text>
                              </Flex>
                            )}
                          </Flex>
                        </Flex>

                        <Wrapper style={{ paddingBottom: '24px' }} >
                          {data.healthCoachListUpcomingAppointments.filter(xx => {
                            return (filtering(xx))
                          }).map((e, i, lst) => <Row
                            previousRow={i === 0 ? null : lst[i - 1]}
                            onGoToProfile={() => {
                              setSelectedAppointment(e)
                            }}
                            hoveredId={hoveredId}
                            setHover={setHoveredId}
                            row={e} />)
                          }
                        </Wrapper>

                        <Flex style={{ borderTop: '2px solid #344F7A', paddingTop: '8px', gap: '12px' }}>
                          <Flex flex={1} />
                          <Text style={{ fontSize: '11px', opacity: 0.83 }}>Unprepped: {getNumbersUnprepped().filtered.toString()}{getNumbersUnprepped().filtered!==getNumbersUnprepped().total?` filtered/${getNumbersUnprepped().total}`:``}</Text>
                          <Text style={{ fontSize: '11px', opacity: 0.83 }}>Prepped: {getNumbersPrepped().filtered.toString()}{getNumbersPrepped().filtered!==getNumbersPrepped().total?` filtered/${getNumbersPrepped().total}`:``}</Text>
                        </Flex>
                      </Flex>
                    </ListContainer>
                  </Flex>
                </Flex>
              </>
            )}
          </>
        )}
      </Flex>
      {selectedAppointment && selectedAppointment.patientId && (
        <PatientDetailsFloatingContainer id='pcs0'>
          <ProfileCardSection athenaId={selectedAppointment.patientId} show hideIcon onCollapse={() => setSelectedAppointment(null)} />
        </PatientDetailsFloatingContainer>
      )}

      <Modal
        isOpen={isSelectfilteredProvider}
        onBackgroundClick={() => setisSelectFilterProvider(false)}
        onEscapeKeydown={() => setisSelectFilterProvider(false)}>
        <Flex flexDirection={'column'} style={{ margin: '0 auto', overflow: 'hidden', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', maxHeight: '80vh' }}>
          <Heading mb={3}>Filter providers</Heading>
          <Flex flex={1} flexDirection={'column'} style={{ overflow: 'auto', padding: '0 24px 0 0' }}>
            {getListProviders().map(x => {
              return (
                <Flex>
                  <Checkbox name={`cjk_${x}`} isChecked={filteredProvider && filteredProvider?.indexOf(x) > -1} onClick={() => {
                    if (filteredProvider.indexOf(x) > -1) {
                      const f = filteredProvider.filter(xx => xx !== x)
                      setFilterProvider(f)
                    } else {
                      setFilterProvider([...filteredProvider, x])
                    }
                  }}
                    label={x} />
                </Flex>
              )
            })}
          </Flex>
          <Flex style={{ gap: '24px' }}>
            <Button variant={'outline'} mt={4} style={{ fontSize: '13px', borderRadius: '6px' }} onClick={() => setFilterProvider(getListProviders().map(x => x))}>Select All</Button>
            <Button variant={'outline'} mt={4} style={{ fontSize: '13px', borderRadius: '6px' }} onClick={() => setFilterProvider([])}>Unselect All</Button>
          </Flex>
          <Button variant={'primary'} mt={4} onClick={() => setisSelectFilterProvider(false)}>Close</Button>

        </Flex>
      </Modal>

      <Modal
        isOpen={isSelectfilteredTypes}
        onBackgroundClick={() => setisSelectFilterTypes(false)}
        onEscapeKeydown={() => setisSelectFilterTypes(false)}>
        <Flex flexDirection={'column'} style={{ margin: '0 auto', overflow: 'hidden', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', maxHeight: '80vh' }}>
          <Heading mb={3}>Filter Visit Types</Heading>
          <Flex flex={1} flexDirection={'column'} style={{ overflow: 'auto', padding: '0 24px 0 0' }}>
            {VISIT_TYPES.map(x => {
              return (
                <Flex>
                  <Checkbox name={`cjk_${x}`} isChecked={filteredTypes && filteredTypes?.indexOf(x) > -1} onClick={() => {
                    if (filteredTypes.indexOf(x) > -1) {
                      const f = filteredTypes.filter(xx => xx !== x)
                      setFilterTypes(f)
                    } else {
                      setFilterTypes([...filteredTypes, x])
                    }
                  }}
                    label={x} />
                </Flex>
              )
            })}
          </Flex>
          <Flex style={{ gap: '24px' }}>
            <Button variant={'outline'} mt={4} style={{ fontSize: '13px', borderRadius: '6px' }} onClick={() => setFilterTypes(VISIT_TYPES.map(x => x))}>Select All</Button>
            <Button variant={'outline'} mt={4} style={{ fontSize: '13px', borderRadius: '6px' }} onClick={() => setFilterTypes([])}>Unselect All</Button>
          </Flex>
          <Button variant={'primary'} mt={4} onClick={() => setisSelectFilterTypes(false)}>Close</Button>

        </Flex>
      </Modal>
      {!!data?.healthCoachListUpcomingAppointments && (
        <Modal
          isOpen={isSelectfilteredDates}
          onBackgroundClick={() => setisSelectFilterDates(false)}
          onEscapeKeydown={() => setisSelectFilterDates(false)}>
          <Flex flexDirection={'column'} style={{ margin: '0 auto', overflow: 'hidden', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', maxHeight: '80vh' }}>
            <Heading mb={3}>Filter By Dates</Heading>
            <Flex flex={1} flexDirection={'column'} style={{ overflow: 'auto', padding: '0 24px 0 0', gap: '12px' }}>
              <DatePicker
                customInput={<InputNoForm />}
                selectsRange
                selectsDisabledDaysInRange
                inline
                onChange={dates => {
                  const [start, end] = dates
                  let filteredDates = {
                    startDate: start,
                    endDate: end
                  }
                  setFilterDates(filteredDates)
                }}
                selected={filteredDates?.startDate}
                startDate={filteredDates?.startDate}
                endDate={filteredDates?.endDate}
                minDate={getDatesRange().from}
                maxDate={getDatesRange().to}
              />
              {/* <DatePicker
            customInput={<InputNoForm />}
            /> */}

              {/* <Text>{filteredDates?.startDate?.toDateString()} - {filteredDates?.endDate?.toDateString()}</Text> */}
            </Flex>
            <Flex style={{ gap: '24px' }}>
              <Button variant={'outline'} mt={4} style={{ fontSize: '13px', borderRadius: '6px' }} onClick={() => setFilterDates(null)}>Reset</Button>
            </Flex>
            <Button variant={'primary'} mt={4} onClick={() => setisSelectFilterDates(false)}>Close</Button>

          </Flex>
        </Modal>
      )}

      <Modal
        isOpen={isSelectfilteredMember}
        onBackgroundClick={() => setisSelectFilterMember(false)}
        onEscapeKeydown={() => setisSelectFilterMember(false)}>
        <Flex flexDirection={'column'} style={{ margin: '0 auto', overflow: 'hidden', alignSelf: 'center', borderRadius: '20px', position: 'relative', backgroundColor: 'white', padding: '24px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', maxHeight: '80vh' }}>
          <Heading mb={3}>Filter Members</Heading>
          <Text><span style={{ fontWeight: 500, color: 'orange' }}>WARNING:</span> This relies solely on appointment type</Text>
          <Flex flex={1} flexDirection={'column'} style={{ overflow: 'auto', padding: '0 24px 0 0' }}>

            <Button style={{ padding: '8px 25px' }} mt={3} variant={filteredMember.indexOf('all') > -1 ? 'pink' : 'outline'} onClick={() => {
              setFilterMember(['all'])
            }}>All</Button>

            <Button style={{ padding: '8px 25px' }} mt={2} variant={filteredMember.indexOf('member') > -1 ? 'pink' : 'outline'} onClick={() => {
              let f: Array<"all" | "member" | "nonmember" | "zocdoc"> = filteredMember.filter(x => x !== 'all')
              if (f.indexOf('member') < 0) {
                f.push('member')
              } else {
                f = f.filter(x => x !== 'member')
              }
              if (f.length < 1) {
                f.push('all')
              }
              setFilterMember(f)
            }}>Members</Button>

            <Button style={{ padding: '8px 25px' }} mt={2} variant={filteredMember.indexOf('nonmember') > -1 ? 'pink' : 'outline'} onClick={() => {
              let f: Array<"all" | "member" | "nonmember" | "zocdoc"> = filteredMember.filter(x => x !== 'all')
              if (f.indexOf('nonmember') < 0) {
                f.push('nonmember')
              } else {
                f = f.filter(x => x !== 'nonmember')
              }
              if (f.length < 1) {
                f.push('all')
              }
              setFilterMember(f)
            }}>Non Members</Button>

            <Button style={{ padding: '8px 25px' }} mt={2} variant={filteredMember.indexOf('zocdoc') > -1 ? 'pink' : 'outline'} onClick={() => {
              let f: Array<"all" | "member" | "nonmember" | "zocdoc"> = filteredMember.filter(x => x !== 'all')
              if (f.indexOf('zocdoc') < 0) {
                f.push('zocdoc')
              } else {
                f = f.filter(x => x !== 'zocdoc')
              }
              if (f.length < 1) {
                f.push('all')
              }
              setFilterMember(f)
            }}>ZocDoc</Button>

            <Button mt={4} style={{ padding: '8px 25px' }} variant={'primary'} onClick={() => setisSelectFilterMember(false)}>Close</Button>
          </Flex>
        </Flex>
      </Modal>
    </Container>
  )
}